import { useState } from 'react';

const projectTypes = [
  'Vibe coded app rescue',
  'Fractional CTO',
  'Architecture review',
  'New product build',
  'Technical advisory',
  'Partnership',
  'Other',
];

const field =
  'w-full px-4 py-3 bg-transparent border border-white/20 rounded-md text-white placeholder-white/35 focus:outline-none focus:border-[#2563eb] transition-colors';
const label = 'block text-white/60 text-xs uppercase tracking-[0.2em] font-medium mb-2';

export function NoteForm() {
  const [projectType, setProjectType] = useState(projectTypes[0]);
  const [status, setStatus] = useState<'idle' | 'sending' | 'error'>('idle');

  return (
    <form
      className="max-w-2xl space-y-6"
      onSubmit={async (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        const data = {
          name: (form.elements.namedItem('name') as HTMLInputElement).value,
          email: (form.elements.namedItem('email') as HTMLInputElement).value,
          phone: (form.elements.namedItem('phone') as HTMLInputElement).value || undefined,
          projectType,
          message: (form.elements.namedItem('message') as HTMLTextAreaElement).value,
        };
        setStatus('sending');
        try {
          const res = await fetch('/api/email/send-message', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
          });
          if (!res.ok) throw new Error(String(res.status));
          window.location.href = '/contact/confirmation/general-contact';
        } catch {
          setStatus('error');
        }
      }}
    >
      <div className="grid sm:grid-cols-2 gap-6">
        <div>
          <label className={label} htmlFor="c-name">
            Name
          </label>
          <input
            id="c-name"
            name="name"
            type="text"
            required
            autoComplete="name"
            className={field}
          />
        </div>
        <div>
          <label className={label} htmlFor="c-email">
            Email
          </label>
          <input
            id="c-email"
            name="email"
            type="email"
            required
            autoComplete="email"
            className={field}
          />
        </div>
        <div>
          <label className={label} htmlFor="c-phone">
            Phone (optional)
          </label>
          <input id="c-phone" name="phone" type="tel" autoComplete="tel" className={field} />
        </div>
      </div>
      <fieldset>
        <legend className={label}>What this is about</legend>
        <div className="flex flex-wrap gap-2 mt-1" role="radiogroup">
          {projectTypes.map((t) => {
            const on = t === projectType;
            return (
              <button
                key={t}
                type="button"
                role="radio"
                aria-checked={on}
                onClick={() => setProjectType(t)}
                className={`px-4 py-2 rounded-md text-sm font-medium border transition-colors ${
                  on
                    ? 'border-transparent'
                    : 'border-white/20 text-white/75 hover:border-white/50 hover:text-white'
                }`}
                style={
                  on
                    ? { backgroundColor: 'var(--ink, #0a0a0b)', color: 'var(--paper, #fafafa)' }
                    : undefined
                }
              >
                {t}
              </button>
            );
          })}
        </div>
      </fieldset>
      <div>
        <label className={label} htmlFor="c-message">
          What you are building and where it is stuck
        </label>
        <textarea
          id="c-message"
          name="message"
          required
          rows={6}
          className={`${field} resize-none`}
        />
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <button
          type="submit"
          disabled={status === 'sending'}
          className="button-primary rounded-md px-7 py-3.5 text-base font-semibold disabled:opacity-60"
        >
          {status === 'sending' ? 'Sending' : 'Send the note'}
        </button>
        {status === 'error' && (
          <p className="text-sm text-red-500">
            The note did not send. Email{' '}
            <a href="mailto:discovery@7sigma.io" className="underline underline-offset-4">
              discovery@7sigma.io
            </a>{' '}
            instead.
          </p>
        )}
      </div>
    </form>
  );
}
